import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { Textarea } from 'primeng/textarea';
import ApplicationSettingsWriteDTO from '../../../../types/application-settings/ApplicationSettingsWriteDTO';
import { IsAdminDirective } from '../../directives/is-admin.directive';
import { ApplicationSettingsService } from '../../services/application-settings.service';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';

@Component({
    selector: 'app-application-settings',
    imports: [
        PageHeaderComponent,
        IconField,
        IftaLabelModule,
        InputIcon,
        ReactiveFormsModule,
        Button,
        FormsModule,
        Textarea,
        IsAdminDirective
    ],
    templateUrl: './application-settings.component.html',
    styleUrl: './application-settings.component.scss'
})
export class ApplicationSettingsComponent implements OnInit {

    public settings: ApplicationSettingsWriteDTO = new ApplicationSettingsWriteDTO({});
    public loading: boolean = false;

    constructor(private applicationSettingsService: ApplicationSettingsService,
                private messageService: MessageService) {
    }

    /**
     * Initializes the component
     */
    public ngOnInit(): void {
        this.loadSettings();
    }

    /**
     * Saves the application settings
     */
    public saveSettings(): void {
        this.loading = true;
        this.applicationSettingsService.updateApplicationSettings(this.settings).then(() => {
            this.messageService.add(
                { severity: 'success', summary: 'Success', detail: 'Application settings updated' });
        }).catch((error) => {
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: error.message }
            );
        }).finally(() => {
            this.loading = false;
        });
    }

    /**
     * Loads the application settings
     */
    private loadSettings(): void {
        this.applicationSettingsService.getApplicationSettings().then((settings) => {
            this.settings = new ApplicationSettingsWriteDTO(settings);
        }).catch(() => {
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: 'Failed to load application settings' }
            );
        });
    }
}
